import React from 'react';

import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';

import './SkuReportsVenueLabel.scss';

const { block, element } = bem('sku-reports-venue-label');

const EMPTY_VALUE = '—';

const VenueLabel = ({ name, subtitle }) => (
  <span className={block()}>
    <span>{name || EMPTY_VALUE}</span>
    {subtitle && <span className={element('subtitle')}>{subtitle}</span>}
  </span>
);

VenueLabel.propTypes = {
  name: PropTypes.string,
  subtitle: PropTypes.string,
};

export default VenueLabel;
